import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "relative w-full h-full p-5 bg-white border border-darkgray-900/[.04] rounded-2xl cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "w-3 h-3 rounded-full block absolute right-4 top-4 bg-[#C20000]"
}
const _hoisted_3 = { class: "mb-1 font-bold text-primary-500" }
const _hoisted_4 = { class: "text-darkgray-900" }

import { format } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'TestResultCard',
  props: {
    item: {
        type: Object,
        default: () => {
            return {};
        }
    },
    badge : {
        default: false,
        type: Boolean
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.badge)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.item.laboratory_type) + " ", 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.item.created_date ? _unref(format)(new Date(__props.item.created_date ), 'EEE, MMM dd, Y') : 'Date') + " ", 1)
  ]))
}
}

})